import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import PricingSubpageSection1 from "../../components/Pricing/PricingSubpageSection1/PricingSubpageSection1";
import CoreVirtuesValues from "../../components/CoreVirtuesValues/CoreVirtuesValues";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";

const Software = () => {
  const { t } = useTranslation("global");
  
  const basicPlanFeatures = [
    t("software.basicFeature1"),
    t("software.basicFeature2"),
    t("software.basicFeature3"),
  ];

  const standardPlanFeatures = [
    t("software.standardFeature1"),
    t("software.standardFeature2"),
    t("software.standardFeature3"),
    t("software.standardFeature4"),
  ];

  const enterprisePlanFeatures = [
    t("software.enterpriseFeature1"),
    t("software.enterpriseFeature2"),
    t("software.enterpriseFeature3"),
  ];
  
  return (
    <>
      <Navbar />
      <PricingSubpageSection1
        mainTitle={t("software.mainTitle")}
        subtitleText={t("software.subtitleText")}
        basicPlanTitle={t("software.basicPlanTitle")}
        basicPlanDescription={t("software.basicPlanDescription")}
        basicPlanFeatures={basicPlanFeatures}
        standardPlanTitle={t("software.standardPlanTitle")}
        standardPlanDescription={t("software.standardPlanDescription")}
        standardPlanFeatures={standardPlanFeatures}
        enterprisePlanTitle={t("software.enterprisePlanTitle")}
        enterprisePlanDescription={t("software.enterprisePlanDescription")}
        enterprisePlanFeatures={enterprisePlanFeatures}
      />
      <CoreVirtuesValues />
      <Footer />
    </>
  );
};

export default Software;